<template >
    <div v-if="results?.length" class="res-card mb-2">

      <template v-for="(meet, idx) in results"  :key="idx">
        <div class="res-card-header sub-header geoff-border-bottom p-n fs-15 fw-600">{{ meet.eventName }} results {{ meet.date }}</div>
          <swiper
            v-if="meet.eventDetails"
            slidesPerView="auto"
            :centeredSlides="false"
            :spaceBetween="$store.state.isMobile ? 16 : 32"
            :navigation="$store.state.isMobile ? false : true"
            :modules="modules"
            :loop="false"
            class="swiper-nav-semitransparent">
            <swiper-slide
              v-for="(event, index) in meet.eventDetails"
              :key="index"
              class="slide-item-wr"
              :class="{
                'desktop-slide': !$store.state.isMobile,
                'mobile-slide': $store.state.isMobile
                }"
            >
              <div  class="balls-wr px-n pb-3">
                <lotto-meeting-result :is-smaller="true" :meeting="event"></lotto-meeting-result>
              </div>
            </swiper-slide>
          </swiper>
      </template>
    </div>
</template>

<script>
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { Navigation } from "swiper";
  import LottoMeetingResult from "@/components/Sport/Lotto/LottoMeetingResult";
  import "swiper/css";
  import "swiper/css/navigation";

  export default {
    name: "LottoResultsSlider",
    components: {
      Swiper, 
      SwiperSlide, 
      LottoMeetingResult
    },
    setup() {
      return {
        modules: [Navigation],
      };
    },
    props: ['lotto'],
    data: () => {
      return {
        results: [],
        intervalLoad: null
      }
    },
    mounted() {
      this.loadResults()
      this.intervalLoad = setInterval(()=> this.loadResults(), 5000)
    },
    beforeUnmount(){
      if (this.intervalLoad) clearInterval(this.intervalLoad)
    },
    methods: {
      loadResults() {
        this.API.getLottoResults()
          .then(data => {
            this.results = data
          })
      }
    }
  }
</script>

<style scoped lang="scss">
  .res-card{
    width: auto;
    background-color: var(--geoff-bg-section);
    border-radius: 0.25rem;

    .event-details-wr {
      display: flex;
      gap: 0 2rem;
      flex-wrap: wrap;
    }
  }

  .racer-image-wr {
    max-width: 2rem;
  }

  .balls-wr {
    display: flex;
    gap: 2rem 3rem;
    margin-top: 0.5rem;
    flex-wrap: wrap;

    .main-balls {
      display: flex;
      gap: 0.5rem;
    }
  }

  .slide-item-wr {

    background-color: var(--geoff-bg-section);
    border-radius: 0.25rem;

    &.mobile-slide {
      width: unset;
      max-width: unset;
    }

    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }

    &.desktop-slide {
      width: unset;
      max-width: unset;
    }

  }
</style>